<template>
  <div>
    <div class="mb-3">
      <div class="section-title mb-3">{{ $t("accerssrightforfnb") }}</div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-3 d-flex">
          <div class="dropdown-curve-container">
            <multiselect
              class="selectCinemaDandD"
              v-model="selectedCinema"
              :placeholder="''"
              :options="Cinemas"
              @select="onSelectCinema($event, 'add')"
              @remove="onSelectCinema($event, 'remove')"
              label="cine_name"
              track-by="cine_id"
              selectLabel="Select"
              deselectLabel="✖"
              :multiple="false"
            ></multiselect>
            <label :class="selectedCinema ? 'shift-up' : ''">
              {{ $tc("cinema", 2) }}
            </label>
          </div>
        </div>
        <div class="col-lg-6 col-xl-3 d-flex">
          <div class="dropdown-curve-container">
            <multiselect
              v-model="SelectedFnbItems"
              :options="FnbItemList"
              :placeholder="''"
              @select="onSelectHandler('item', $event)"
              @remove="onRemoveHandler('item')"
              label="item_name"
              track-by="item_id"
              selectLabel="Select"
              deselectLabel="✖"
              :multiple="false"
            ></multiselect>
            <label :class="selected.ItemID ? 'shift-up' : ''"> Fnb Item </label>
          </div>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center mb-1" v-if="false">
          <div class="dropdown-curve-container">
            <label :class="selected.Date.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $t("to") }} {{ $tc("date", 2) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selected.Date"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Item, ItemIndex) in Dates"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectHandler('date', Item)"
                  >{{ Item }}</b-dropdown-item
                >
                <b-dropdown-item @click="onSelectHandler('dateAll')"
                  >All</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-xl-2 align-self-center mb-4">
          <div class="input-material">
            <div class="add-datepicker">
              <Datepicker
                :monday-first="true"
                ref="programaticOpen"
                v-model="selected.fromDate"
                name="selectenddate_1"
                id="selectenddate_1"
                v-validate="'required'"
                :typeable="true"
              ></Datepicker>
              <label :class="selected.fromDate ? 'active' : ''">{{
                $t("fromdate")
              }}</label>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-xl-2 align-self-center mb-4">
          <div class="input-material">
            <div class="add-datepicker">
              <Datepicker
                :monday-first="true"
                ref="programaticOpen"
                v-model="selected.toDate"
                name="selectenddate_1"
                id="selectenddate_1"
                v-validate="'required'"
                :typeable="true"
              ></Datepicker>
              <label :class="selected.toDate ? 'active' : ''">{{
                $t("todate")
              }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-xl-2 align-self-center mb-4">
          <button @click.prevent.stop="onFetch()" class="btn-blue m-0">
            {{ $t("submit") }}
          </button>
        </div>
        <div
          v-if="FnBRecords[0] && FnBRecords[0].length > 0"
          class="col-12 align-self-center d-flex justify-content-end mt-2 mb-2"
        >
          <a target="_blank" title="Download as Excel" @click="excelDownload()">
            Download
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>#</th>
              <th>{{ $t("itemname") }}</th>
              <th>
                <img
                  v-if="this.columnName != 'fp_from_date'"
                  @click="onSortValue('fp_from_date', 'asc')"
                  src="@/assets/img/icons/updown.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else-if="isSort && isAscending"
                  @click="onSortValue('fp_from_date', 'asc')"
                  src="@/assets/img/icons/asc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else
                  @click="onSortValue('fp_from_date', 'desc')"
                  src="@/assets/img/icons/desc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                {{ $t("fromdate") }}
              </th>
              <th>
                <img
                  v-if="this.columnName != 'fp_to_date'"
                  @click="onSortValue('fp_to_date', 'asc')"
                  src="@/assets/img/icons/updown.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else-if="isSort && isAscending"
                  @click="onSortValue('fp_to_date', 'asc')"
                  src="@/assets/img/icons/asc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else
                  @click="onSortValue('fp_to_date', 'desc')"
                  src="@/assets/img/icons/desc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                {{ $t("todate") }}
              </th>
              <th style="text-align: center">{{ $t("users") }}</th>
            </tr>
          </thead>
          <tbody
            v-if="FnBRecords[0] && FnBRecords[0].length > 0"
            v-for="(fnb, fnbIndex) in FnBRecords[0]"
            :key="fnbIndex"
            class="light_grey_back"
          >
            <td class="hei">{{ fnbIndex + 1 }}</td>
            <td class="hei">{{ fnb.item_name }}</td>
            <td class="hei">{{ fnb.fp_from_date | dateparse }}</td>
            <td class="hei">{{ fnb.fp_to_date | dateparse }}</td>
            <td class="hei">
              <multiselect
                :disabled="!$can('update', 'Access Rights For FnB')"
                v-model="fnb.selectedUsers"
                track-by="user_id"
                label="username"
                @select="onSelect(fnb, $event, 'Selected')"
                @remove="onSelect(fnb, $event, 'Removed')"
                :options="Users"
                :multiple="true"
              ></multiselect>
            </td>
          </tbody>

          <tbody v-if="FnBRecords.length == 0 || FnBRecords[0].length == 0">
            <td colspan="5">
              <NoRecords />
            </td>
          </tbody>
        </table>
      </div>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import MovieService from "@/services/MovieService";
  import signageServices from "@/services/signageService";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import DatePicker from "vue2-datepicker";
  import VueTimepicker from "vue2-timepicker";
  import "vue2-timepicker/dist/VueTimepicker.css";
  import moment from "moment";
  import xlsx from "json-as-xlsx";

  export default {
    name: "access-rights-for-schedule",
    components: {
      NoRecords,
      DatePicker,
      VueTimepicker,
    },
    data() {
      return {
        Cinemas: [],
        selectedCinema: "",
        cinema_id: null,
        perPage: 10,
        currentPage: 1,
        rows: 0,
        selectedvalue: "10",
        FnBRecords: [],
        TempData: [],
        selectedUsers: [],
        viewingnumbers: [],
        Users: [],
        Dates: [],
        selected: {
          item: "",
          ItemID: "",
          Date: "",
          fromDate: "",
          toDate: "",
        },
        FnbItemList: [],
        SelectedFnbItems: [],

        isSort: false,
        isAscending: true,
        orderby: "",
        columnName: "",
      };
    },
    computed: {
      viewingRange() {
        if (this.rows === 0) {
          return "Viewing 0 to 0 of 0";
        }

        const start = (this.currentPage - 1) * this.perPage + 1;
        const end = Math.min(this.currentPage * this.perPage, this.rows);

        return `Viewing ${start} to ${end} of ${this.rows}`;
      },
    },

    beforeMount() {
      const {cinema_id } = this.secureStore.get("USINFO");
      this.getCinemaList(cinema_id);
    },
    mounted() {
      this.getviewingnumber();
      // this.getFnbBasedItems();
      this.GetFnbItems();
      this.getAllToDates();
      this.getPosAggregatorUsers();
    },
    methods: {
      onFetch: function() {
        if (this.selectedCinema) {
          this.getFnbBasedItems();
        } else {
          this.$toasted.show("select cinema");
        }
      },
      onSelectCinema(cinema, type = "add") {
        if (type == "add") {
          this.selectedCinema = cinema;
          this.cinema_id = cinema.cine_id;
          this.selected.ItemID = null;
          this.selected.item = "All";
          this.SelectedFnbItems = "";
          this.GetFnbItems();
          // this.getFnbBasedItems();
        } else {
          this.selectedCinema = "";
          this.cinema_id = null;
          this.selected.ItemID = null;
          this.selected.item = "All";
          this.SelectedFnbItems = "";
          this.GetFnbItems();
          // this.getFnbBasedItems();
        }
      },
      getCinemaList: function(cinema_id) {
        MasterService.GetCinemas({cine_id: cinema_id})
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              if (data.Records && data.Records.length === 1) {
                this.onSelectCinema(data.Records[0], "add");
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {});
      },
      getviewingnumber() {
        this.viewingnumbers = [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ];
      },
      onSortValue(columnName, orderby) {
        this.isSort = true;
        this.isAscending = !this.isAscending;
        this.columnName = columnName;
        this.orderby = orderby;
        this.getFnbBasedItems();
      },
      onDropDownChangeValue(event) {
        if (event == "All") {
          this.perPage = this.rows;
          this.selectedvalue = event;
          this.onChangePagination();
        } else {
          console.log("Numbers :", event);
          this.selectedvalue = event;
          this.perPage = event;
          console.log("perPage :", this.perPage);
          this.onChangePagination();
        }
      },

      /* eslint-disable */
      onChangePagination: function(event) {
        // console.log(event);
        if (event === undefined) {
          this.currentPage = 1;
          this.getFnbBasedItems();
        } else {
          this.currentPage = event;
          this.getFnbBasedItems();
        }
      },
      validateDate(showError = true) {
        let errorCount = 0;
        let errMsg = "";

        if (this.selected.fromDate && !moment(this.selected.toDate).isValid()) {
          errorCount++;
          errMsg = "Please Select To Date";
        } else if (
          !moment(this.selected.fromDate).isValid() &&
          this.selected.toDate
        ) {
          errorCount++;
          errMsg = "Please Select From Date";
        } else if (
          moment(this.selected.fromDate).isAfter(this.selected.toDate)
        ) {
          errorCount++;
          errMsg = "From Date must be smaller than To Date";
        }

        if (errorCount > 0) {
          if (showError) {
            this.$toasted.show(errMsg);
          }
          return false;
        } else {
          return true;
        }
      },
      getFnbBasedItems: function() {
        console.log("this.validateDate()", this.validateDate());
        if (!this.validateDate()) {
          return;
        } else {
          let loader = this.$loading.show();
          let payload = {
            item_id: this.selected.ItemID,
            cinema_id: this.cinema_id || null,
            date: this.selected.Date == "All" ? "" : this.selected.Date,
            from_date: moment(this.selected.fromDate).isValid()
              ? moment(this.selected.fromDate).format("YYYY-MM-DD")
              : "",
            to_date: moment(this.selected.toDate).isValid()
              ? moment(this.selected.toDate).format("YYYY-MM-DD")
              : "",
            limit: this.perPage,
            currentPage: this.currentPage,
            columnName: this.columnName,
            orderBy: this.orderby,
          };
          MasterService.GetFnbBasedItems(payload)
            .then((response) => {
              const { data } = response;
              loader.hide();
              if (data && data.status) {
                if (data.Records && data.Records.length > 0) {
                  this.FnBRecords = data.Records;
                  if (data.totalRows >= 10) {
                    this.rows = data.totalRows;
                    this.selectedvalue =
                      this.selectedvalue < 10 ? 10 : this.selectedvalue;
                  } else {
                    this.rows = data.totalRows;
                    this.selectedvalue = data.totalRows;
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              } else {
                this.$toasted.show(data.message);
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            })
            .catch(this._CatchError)
            .finally(() => {
              setTimeout(() => loader.hide(), 1000);
            });
        }
      },
      excelDownload() {
        let temp_data = this.FnBRecords[0];
        let temp_arr = [];
        temp_data.map((x) => {
          x.selectedUsers.map((y) => {
            let obj = {
              ...x,
              ...y,
            };
            temp_arr.push(obj);
          });
        });
        console.log({ temp_arr });
        let dateparse = function(value) {
          if (!value) return "-";
          else if (value === "Invalid date") return "-";
          else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
            return value
              ? moment(value, "DD-MM-YYYY HH:mm").format("DD MMM YYYY")
              : "-";
          //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
          //this is changed acc to mams decision
          else
            return value
              ? moment(value).format("DD-MM-YYYY") === "Invalid date"
                ? "-"
                : moment(value).format("DD MMM YYYY")
              : "-";
        };

        let data = [
          {
            sheet: "Access Rights For F&B",
            columns: [
              {
                value: "item_name",
                label: "Item Name",
              },
              {
                value: (row) => dateparse(row.fp_from_date),
                label: "From Date",
              },
              {
                value: (row) => dateparse(row.fp_to_date),
                label: "To Date",
              },
              {
                value: (row) => (row.username == "website" ? "Yes" : "-"),
                label: "Website",
              },
              {
                value: (row) => (row.username == "kiosk" ? "Yes" : "-"),
                label: "Kiosk",
              },
              {
                value: (row) => (row.username == "POSUSERS" ? "Yes" : "-"),
                label: "Pos User",
              },

              //      Sold: 0,
              // gross_amount: 0,
              // offer_price: 0,
              // total_taxes: 0,
              // final_gross_amount: 0
            ],
            content: temp_arr,
          },
        ];
        let settings = {
          fileName: `AccessRightsForF&B${new Date().getTime()}`,
        };
        xlsx(data, settings);
      },
      GetFnbItems: function() {
        this.FnbList = [];
        let loader = this.$loading.show();

        let payload = {
          cinema_id: this.cinema_id,
        };

        signageServices
          .GetFnBListSignages(payload)
          .then((response) => {
            const { data } = response;

            if (data.status) {
              if (data.Records && data.Records.length > 0) {
                this.FnbItemList = data.Records;

                this.FnbItemList.push({ item_id: 0, item_name: "All" });
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
      getAllToDates: function() {
        MasterService.GetAllToDates()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.Dates = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectHandler: function(type, value) {
        if (type == "item") {
          if (value["item_id"] == 0) {
            this.selected.ItemID = null;
            this.selected.item = "All";
          } else {
            this.selected.ItemID = value.item_id;
            this.selected.item = value.item_name;
          }
          // this.getFnbBasedItems();
        } else if (type == "date") {
          this.selected.Date = value;
        } else if (type == "dateAll") {
          this.selected.Date = "All";
        }
      },
      onRemoveHandler: function(type) {
        if (type == "item") {
          this.selected.ItemID = null;
          this.selected.item = "All";
          this.SelectedFnbItems = "";
        } else if (type == "date") {
          this.selected.Date = "All";
        }
      },

      getPosAggregatorUsers: function() {
        MasterService.GetFnBPosAggregatorUsers()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.Users = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelect: function(fnb, event, type) {
        let payload = {
          item_id: fnb.item_id,
          user_id: event.user_id,
        };

        if (type == "Selected") {
          payload.afm_is_active = false;
        } else if (type == "Removed") {
          payload.afm_is_active = true;
        }

        MasterService.SetAccessFnBMapping(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.$toasted.show(data.message);
              this.getFnbBasedItems();
              this.GetFnbItems();
              this.getPosAggregatorUsers();
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
    },
  };
</script>

<style>
  .light_grey_back:nth-child(odd) {
    background-color: #fff;
  }
  .hei {
    padding: 0.35rem !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/AccessRightsComponents/AccessRightsForFnB.vue